import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { withTranslation } from 'react-i18next';

import InventoryDetailsForm from './InventoryDetailsForm';
import getInventoryDetailsFormSchema from '../../../formSchemas/InventoryDetailsFormSchema';
import GenericDetails from '../../common/GenericDetails';
import { inventoriesHistoryActions } from '../../../behavior/inventories/history';
import { entityType, VIEW_MODE } from '../../../constants';
import Inventory from '@src/objects/Inventory';

type Props = {
  isLoading: Boolean;
  inventory: Inventory;
  initialData: any;
  getInitialData: (arg: number) => void;
  getInventoryHistory: (arg: number) => void;
  id: number;
  disabled: boolean;
};

const InventoryHistoryDetailsFormContainer = ({
  isLoading,
  inventory,
  initialData,
  getInitialData,
  getInventoryHistory,
  id,
  disabled,
}: Props) => {
  let invId = inventory ? inventory.inventoryId : null;

  useEffect(() => {
    getInitialData(id);
    getInventoryHistory(id);
  }, [id]);

  return (
    <GenericDetails
      initialValues={inventory}
      validationSchema={getInventoryDetailsFormSchema()}
      initialData={initialData}
      mode={VIEW_MODE}
      isLoading={isLoading}
      isHistory={true}
      id={invId}
      entityTypeProp={entityType.inventoryHist}
      renderContainer={(props: any) => <InventoryDetailsForm {...props} isHistory={true} />}
      disabled={disabled}
    />
  );
};

const mapStateToProps = (state: any, ownProps: any) => ({
  ...state.inventoriesHistory,
  id: ownProps.match.params.id,
});

const mapDispatchToProps = (dispatch: any) => ({
  getInventoryHistory: (id: number) => dispatch(inventoriesHistoryActions.getInventoryHistory(id)),
  getInitialData: (id: number) => dispatch(inventoriesHistoryActions.getInitialData(id)),
});

InventoryHistoryDetailsFormContainer.defaultProps = {
  initialData: {},
  inventory: null,
};

export default compose(connect(mapStateToProps, mapDispatchToProps))(
  InventoryHistoryDetailsFormContainer
);
